import { MilesTable, TitledContainer } from 'components';

import { useGetRequest } from 'hooks';

import { OpsCorrectionQueues } from 'codegen';

import { columns } from './lib';

export const Queues = () => {
  const { loading, data } = useGetRequest<OpsCorrectionQueues>({
    url: '/corrections/queues',
  });

  const queues = data?.queues;

  return (
    <TitledContainer title='Queues'>
      <MilesTable
        loading={loading}
        columns={columns}
        dataSource={queues}
      />
    </TitledContainer>
  );
};
